<template>
    <!--备注-->
    <pop-form class="form-box" :state="show" width="580px" body-max-height="350px">
        <template slot="title">备注</template>
        <div class="body-box">
            <el-input type="textarea" :rows="4" placeholder="" v-model="remark" />
        </div>
        <template v-slot:foot>
            <div class="foot-box">
                <el-button size="medium" @click="close">&nbsp;&nbsp;取消&nbsp;&nbsp;</el-button>
                <el-button size="medium" type="primary" @click="editSubmit">&nbsp;&nbsp;确定&nbsp;&nbsp;</el-button>
            </div>
        </template>
    </pop-form>
</template>

<script>
    import PopForm from "@/model/PopForm";
    export default {
        name: "CashRemark",
        components: {PopForm},
        model: {
            prop: "show",
            event: "showChange"
        },
        props: {
            show: {
                type: Boolean,
                default: true
            },
            initData: {
                type: String,
                default: ""
            }
        },
        data: () => ({
            remark: ""
        }),
        methods: {
            close: function () {
                this.$emit("showChange", false);
            },
            editSubmit: function () {
                this.$emit("submit", this.remark);
                this.close();
            }
        },
        watch: {
            show: function (state) {
                if(state){
                    this.remark = this.initData;
                }
            }
        }
    }
</script>

<style scoped>
    .body-box{
        padding: 10px 10px 0px;
    }
    .foot-box{
        padding: 0 20px 10px;
        text-align: right;
    }
</style>
